import { compose } from 'recompose'
import { React, styled, Image } from 'x'
import { Content } from 'components/common'

const Banner = styled.div`
  display: block;
`

const enhance = compose()

const PromoBanner = (props) => {
  const { pbImage, pbBackgroundColour } = props.globalData

  const StaticImage = styled.div`
    background: url(${(props) => props.url}) center;
    background-size: cover;
    flex: 1 0 auto;
    max-width: 100%;
    min-height: 22vw;
  `

  return (
    <Banner style={{ backgroundColor: pbBackgroundColour }}>
      <Content>
        {pbImage?.imgixImageWp?.fluid && (
          <Image
            fluid={{
              ...pbImage.imgixImageWp.fluid,
              sizes: '100vw',
            }}
          />
        )}
        {!props?.globalData?.pbImage?.imgixImageWp && pbImage && (
          <StaticImage url={pbImage.url} />
        )}
      </Content>
    </Banner>
  )
}

export default enhance(PromoBanner)
